// extracted by mini-css-extract-plugin
module.exports = {"marquee":"text-marquee_marquee__sdsav","text":"text-marquee_text__IrV5t","is-venue":"text-marquee_is-venue__qjlhZ","is-animated":"text-marquee_is-animated__X3xmp"};